import { AfterContentInit, Component, ContentChildren, Input, OnChanges, QueryList, SimpleChanges } from '@angular/core';
import { ResponsiveDisplayConstants } from '@ddt-web/dom';

import { AccordionPanelComponent } from './accordion-panel';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'bfa-accordion',
	templateUrl: './accordion.component.html',
	styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements AfterContentInit, OnChanges {
	@ContentChildren(AccordionPanelComponent) public panels: QueryList<AccordionPanelComponent>;
	@Input('custom-classes') public customClasses: string = '';
	@Input() public exclusive: boolean = false;
	@Input() public isExpanded: boolean = true;
	@Input() public isCollapsedOnMobile: boolean = true;
	@Input() public shouldCollapseOtherPanels: boolean = false;

	public ngOnChanges(changes: SimpleChanges): void {
		// For Closing all other panels if only one panel should be expanded at a time
		if (this.panels && changes?.isExpanded && this.shouldCollapseOtherPanels) {
			this.panels.toArray().forEach((panel: AccordionPanelComponent) => {
				panel.isCollapsed = !this.isExpanded;
			});
		}
	}

	public ngAfterContentInit(): void {
		this.panels.toArray().forEach((panel: AccordionPanelComponent) => {
			if (this.isExpanded) {
				panel.isCollapsed = false;
			}
			panel.onToggleChange.subscribe(() => {
				this.togglePanel(panel);
			});
		});
		this.collapseOnMobile();
	}

	private togglePanel(panel: AccordionPanelComponent): void {
		if (this.exclusive) {
			this.panels.toArray().forEach(pane => {
				if (pane !== panel) {
					pane.isCollapsed = true;
				}
			});
		}
		panel.isCollapsed = !panel.isCollapsed;
	}

	private collapseOnMobile(): void {
		if (this.isCollapsedOnMobile && window.innerWidth <= ResponsiveDisplayConstants.DEVICE_WIDTH.MOBILE_MAX) {
			this.panels.toArray().forEach(pane => {
				pane.isCollapsed = true;
			});
		}
	}
}
